export default "__VITE_ASSET__HBN8aLPX__";